module.exports = __webpack_public_path__ + "639ba1aa6e7b5b1e795c0e5dca32a15d.svg";